import { Builder } from '@builder.io/react';
import SectionHeading from './SectionHeading';

Builder.registerComponent(SectionHeading, {
  name: 'SectionHeading',
  inputs: [
    {
      name: 'subText',
      type: 'string',
    },
    {
      name: 'title',
      type: 'string',
    },
    {
      name: 'centerText',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'borderLine',
      type: 'boolean',
      defaultValue: true,
    },
  ],
});
